function rootMeanSquareDifference(list, targets) {
  if (list.length !== targets.length) {
    throw new Error("rootMeanSquareDifference list and target lengths are not equal");
  }
  let sumDiffSq = 0;
  for (let i = 0; i < list.length; i++) {
    const diff = targets[i] - list[i];
    sumDiffSq += diff * diff;
  }
  return Math.sqrt(sumDiffSq) / list.reduce((sum, v) => sum + v, 0);
}
export {
  rootMeanSquareDifference
};
//# sourceMappingURL=index243.js.map
